import GlyphIcon from "./GlyphIcon.mjs";

/**
 * Glyphicon 145-folder-open
 * @see {GlyphIcon}
 */
const FolderOpenIcon = class extends GlyphIcon {
	constructor(props) {
		super(props);
		this.state.d="M6.05975,11.51489,4,19.75391V7A2.00006,2.00006,0,0,1,6,5h4.17157a1.99993,1.99993,0,0,1,1.41425.58582L13,7H26a2.00006,2.00006,0,0,1,2,2v1H8A1.9999,1.9999,0,0,0,6.05975,11.51489ZM29.43848,12H9.56152a1.99988,1.99988,0,0,0-1.94024,1.51489L4,28H28l3.37872-13.51489A2,2,0,0,0,29.43848,12Z";
	}
}

export default FolderOpenIcon;
